import {sortBy, trim} from 'lodash';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {AxiosResponse} from 'axios';
import moment from 'moment';
import {TimelineLifeCycleFeature} from '@/views/timeline/features/timeline-life-cycle-feature';


export class MechanicOnlineStatusFeature implements TimelineLifeCycleFeature {

    private static readonly DOM_QUERY_SELECTOR = '[onlinestatus]';
    private static readonly DOM_ATTRIBUTE_SELECTOR = 'onlinestatus';

    private interval: number | undefined;

    initialize(
        timelineEl: HTMLElement,
        config: DisguiseDto.ITimelineFeatureConfig,
        repositionGroupCB: () => void
    ) {
        setTimeout(() => {
            const castedConfig = config as DisguiseDto.TimelineMechanicOnlineStatusFeatureConfigDto;

            const allMatchingElements = timelineEl.querySelectorAll(MechanicOnlineStatusFeature.DOM_QUERY_SELECTOR);
            // 1. find all relevant users from DOM
            // 2. request online status
            // 3. inject online status

            const fastElMap: { [username: string]: HTMLElement } = {};

            for (const currentMatchingEl of allMatchingElements || []) {
                const username = currentMatchingEl.getAttribute(MechanicOnlineStatusFeature.DOM_ATTRIBUTE_SELECTOR);
                const trimmedUsername = trim(username || '');
                if (trimmedUsername !== '') {
                    fastElMap[trimmedUsername] = currentMatchingEl as HTMLElement;
                }
            }

            const allUsernames = Object.keys(fastElMap);
            if (allUsernames.length > 0) {
                this.refreshOnlineStatus(castedConfig, fastElMap, repositionGroupCB);
            }
        });

        return this;
    }

    public destroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    private refreshOnlineStatus(
        config: DisguiseDto.TimelineMechanicOnlineStatusFeatureConfigDto,
        fastElMap: { [username: string]: HTMLElement },
        repositionGroupCB: () => void
    ) {
        HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.UserOnlineStatusDto[]>(
            '/mechanics/jobs/v0/onlinestatus',
        ).then((response: AxiosResponse<DisguiseDto.UserOnlineStatusDto[]>) => {
            if (response.data) {
                if (!this.interval && config.refreshIntervalInSeconds !== undefined) {
                    this.interval = setInterval(() => {
                        this.refreshOnlineStatus(config, fastElMap, repositionGroupCB);
                    }, config.refreshIntervalInSeconds * 1000);
                }

                const sortedTrafficLightConfig = sortBy(
                    config.trafficLightConfigs || [],
                    [(o) => o.diffTresholdInMinutes || 0]
                );

                for (const currentUserOnlineStatus of response.data || []) {

                    if (currentUserOnlineStatus.username && currentUserOnlineStatus.lastSeen) {
                        const htmlElementByUsername = fastElMap[currentUserOnlineStatus.username];
                        if (htmlElementByUsername) {
                            // found
                            const indicatorEl = window.document.createElement('div');
                            indicatorEl.title = 'Zuletzt Verbunden: ' + moment(currentUserOnlineStatus.lastSeen).fromNow()
                                + ' (' + moment(currentUserOnlineStatus.lastSeen).format('DD.MM.YYYY HH:mm') + ')';
                            indicatorEl.style.display = 'inline-block';
                            const diff = moment().diff(moment(currentUserOnlineStatus.lastSeen), 'minutes');
                            let trafficLightColor: string = '';

                            for (const currentTrafficLightConfig of sortedTrafficLightConfig) {
                                if (currentTrafficLightConfig.diffTresholdInMinutes === undefined || (currentTrafficLightConfig.diffTresholdInMinutes <= diff)) {
                                    trafficLightColor = currentTrafficLightConfig.colorHex || '';
                                }
                            }

                            indicatorEl.style.backgroundColor = trafficLightColor;
                            indicatorEl.style.width = '10px';
                            indicatorEl.style.height = '10px';
                            indicatorEl.style.borderRadius = '50%';
                            indicatorEl.style.marginLeft = '4px';

                            if (htmlElementByUsername.firstChild) {
                                htmlElementByUsername.firstChild.remove();
                            }
                            htmlElementByUsername.appendChild(indicatorEl);
                        }
                    }

                    repositionGroupCB();
                }
            }
        });
    }
}
